const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const CONTACT_INITIAL_STATE = {
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  message: "",
  company: "",
};

export function getContactApiUrl() {
  const configured = process.env.REACT_APP_CONTACT_API_URL;
  if (configured) {
    return configured.replace(/\/$/, "");
  }
  return "/api/contact.php";
}

function isValidPhone(phone) {
  const digits = phone.replace(/\D/g, "");
  return digits.length >= 7 && digits.length <= 15;
}

export function validateContactForm(values) {
  const errors = {};
  const firstName = values.firstName.trim();
  const lastName = values.lastName.trim();
  const email = values.email.trim();
  const phone = values.phone.trim();
  const message = values.message.trim();

  if (!firstName) {
    errors.firstName = "First name is required.";
  } else if (firstName.length > 100) {
    errors.firstName = "First name must be at most 100 characters.";
  }

  if (!lastName) {
    errors.lastName = "Last name is required.";
  } else if (lastName.length > 100) {
    errors.lastName = "Last name must be at most 100 characters.";
  }

  if (!email) {
    errors.email = "Email is required.";
  } else if (email.length > 255) {
    errors.email = "Email must be at most 255 characters.";
  } else if (!EMAIL_PATTERN.test(email)) {
    errors.email = "Enter a valid email address.";
  }

  if (!phone) {
    errors.phone = "Phone number is required.";
  } else if (phone.length > 20) {
    errors.phone = "Phone number must be at most 20 characters.";
  } else if (!isValidPhone(phone)) {
    errors.phone = "Enter a valid phone number.";
  }

  if (!message) {
    errors.message = "Message is required.";
  } else if (message.length < 10) {
    errors.message = "Message must be at least 10 characters.";
  } else if (message.length > 5000) {
    errors.message = "Message must be at most 5000 characters.";
  }

  return errors;
}

export async function submitContactForm(values) {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 15000);
  try {
    const response = await fetch(getContactApiUrl(), {
      method: "POST",
      signal: controller.signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        firstName: values.firstName.trim(),
        lastName: values.lastName.trim(),
        email: values.email.trim(),
        phone: values.phone.trim(),
        message: values.message.trim(),
        company: values.company,
      }),
    });

    let data;
    try {
      data = await response.json();
    } catch {
      data = null;
    }

    if (!response.ok) {
      const error = new Error(
        typeof data?.error === "string"
          ? data.error
          : "Unable to submit your message. Please try again.",
      );
      error.errors = data?.errors;
      error.status = response.status;
      throw error;
    }
    if (!data || data.success !== true) {
      throw new Error(
        "We could not confirm your message was received. Please try again or contact us by email.",
      );
    }
    return data;
  } catch (error) {
    if (controller.signal.aborted) {
      throw new Error(
        "Your request timed out, but your message may already have been received. Please contact us by email to confirm before sending it again.",
      );
    }
    if (error instanceof TypeError) {
      throw new Error(
        "Unable to connect. Please check your connection and try again.",
      );
    }
    throw error;
  } finally {
    clearTimeout(timeout);
  }
}
